import React from 'react';
import PropTypes from 'prop-types';
import AdvModal from '../../../CommonComponents/AdvModal';
import { SharingSettings } from '../../../SharingSettings/SharingSettings';
import {
  ListItem,
  UserInformation,
  Name,
  ClientMenuButton,
  ClientOnlineStatus,
  OnlineIcon,
} from './ClientMenuStyles';
import ChangeEmailModal from '../ChangeEmailModal';
import { ClientOfflineModal } from '../ClientOfflineModal';
import { AddClientModal } from '../../../AddClientModal/AddClientModal';
import { ClientAccess } from '../../../ClientAccess/ClientAccess';
import { DeleteClientModal } from '../../../DeleteClientModal/DeleteClientModal';

class ClientMenuView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isClientAccessOpen: false,
      isCloneClientModalOpen: false,
      isDeleteClientModalOpen: false,
      isContextMenuOpen: false,
      isChangeEmailModalOpen: false,
      isClientOfflineModalOpen: false,
    };

    this.toggleContextMenu = this.toggleContextMenu.bind(this);
    this.setIsClientAccessOpen = this.setIsClientAccessOpen.bind(this);
    this.setIsCloneClientModalOpen = this.setIsCloneClientModalOpen.bind(this);
    this.setIsDeleteClientModalOpen = this.setIsDeleteClientModalOpen.bind(this);
    this.closeContextMenu = this.closeContextMenu.bind(this);
    this.openChangeEmailModal = this.openChangeEmailModal.bind(this);
    this.closeChangeEmailModal = this.closeChangeEmailModal.bind(this);
    this.toggleClientOfflineModal = this.toggleClientOfflineModal.bind(this);
  }

  componentDidMount() {
    const { getGliaOnlineStatus, client, showGliaStatus } = this.props;

    if (showGliaStatus) {
      getGliaOnlineStatus(client.Id);
    }
  }

  setIsClientAccessOpen(isOpen) {
    this.setState({ isClientAccessOpen: isOpen });
  }

  setIsCloneClientModalOpen(isOpen) {
    this.setState({ isCloneClientModalOpen: isOpen });
  }

  setIsDeleteClientModalOpen(isOpen) {
    this.setState({ isDeleteClientModalOpen: isOpen });
  }

  toggleClientOfflineModal() {
    const { isClientOfflineModalOpen } = this.state;

    this.setState({ isClientOfflineModalOpen: !isClientOfflineModalOpen });
  }

  toggleContextMenu() {
    const { isContextMenuOpen } = this.state;

    this.setState({ isContextMenuOpen: !isContextMenuOpen });
  }

  closeContextMenu() {
    this.setState({ isContextMenuOpen: false });
  }

  openChangeEmailModal() {
    this.setState({ isChangeEmailModalOpen: true });
  }

  closeChangeEmailModal() {
    this.setState({ isChangeEmailModalOpen: false });
  }

  render() {
    const {
      client,
      isDeleteClientEnabled,
      isCurrentPlan,
      downloadPdf,
      resetPlan,
      viewClientActivity,
      viewClientSettings,
      deleteActionLabel,
      sharingCanChangeOwner,
      sharingCanChangeConsumer,
      isSharingSettingsModalOpen,
      openSharingSettingsModal,
      closeSharingSettingsModal,
      modalErrors,
      setModalErrors,
      canInviteConsumer,
      isOnlineGlia,
      showGliaStatus,
      showFinancialPlanning,
    } = this.props;

    const {
      isClientAccessOpen,
      isCloneClientModalOpen,
      isDeleteClientModalOpen,
      isContextMenuOpen,
      isChangeEmailModalOpen,
      isClientOfflineModalOpen,
    } = this.state;

    return (
      <>
        <UserInformation>
          <ChangeEmailModal
            isOpen={isChangeEmailModalOpen}
            onRequestClose={this.closeChangeEmailModal}
            email={client.Email}
            clientId={client.Id}
          />

          {isClientOfflineModalOpen && (
            <ClientOfflineModal
              isOpen
              onRequestClose={this.toggleClientOfflineModal}
              clientName={`${client.FirstName} ${client.LastName}`}
              clientId={client.Id}
            />
          )}

          <ClientMenuButton onClick={this.toggleContextMenu} onBlur={this.closeContextMenu}>
            <Name>
              {client.FirstName} {client.LastName}
            </Name>
            {showGliaStatus && (
              <ClientOnlineStatus>
                <OnlineIcon online={isOnlineGlia} />
                {isOnlineGlia ? 'Online' : 'Offline'}
              </ClientOnlineStatus>
            )}
          </ClientMenuButton>

          <ul
            className={`client-menu adv-dropdown ${isContextMenuOpen ? 'dropdown-open' : ''}`}
            onClick={this.closeContextMenu}
            role="presentation"
          >
            {client.IsRegistered && (
              <ListItem
                onClick={() => {
                  this.setIsClientAccessOpen(true);
                }}
              >
                <i className="fa fa-cog" />
                Configure Access
              </ListItem>
            )}

            {!client.IsRegistered && canInviteConsumer && (
              <ListItem
                onClick={() => {
                  this.setIsClientAccessOpen(true);
                }}
              >
                <i className="fas fa-sign-in-alt" />
                Invite to Orion Planning
              </ListItem>
            )}

            {showGliaStatus && (
              <ListItem onClick={this.toggleClientOfflineModal}>
                <i className="fas fa-desktop" />
                CoBrowse with Client
              </ListItem>
            )}
            {showFinancialPlanning && (
              <ListItem onClick={() => downloadPdf(client.Id)}>
                <i className="fa fa-download" />
                Download Plan PDF
              </ListItem>
            )}
            {!isCurrentPlan && showFinancialPlanning && (
              <ListItem onClick={() => resetPlan(client.Id)}>
                <i className="fas fa-sync-alt" />
                Reset Financial Plan
              </ListItem>
            )}
            {showFinancialPlanning && (
              <ListItem onClick={() => viewClientSettings(client.Id)}>
                <i className="fa fa-user" />
                Client Settings
              </ListItem>
            )}
            <ListItem onClick={() => viewClientActivity(client.Id)}>
              <i className="fa fa-list-alt" />
              User Activity
            </ListItem>
            <ListItem className="more-actions">
              <i className="fa fa-align-left" />
              More Actions
              <ul className="subnav">
                {showFinancialPlanning && (
                  <ListItem onClick={() => this.setIsCloneClientModalOpen(true)}>
                    <i className="far fa-copy" />
                    Clone Client
                  </ListItem>
                )}
                <ListItem onClick={this.openChangeEmailModal}>
                  <i className="fa fa-envelope" />
                  Change Email Address
                </ListItem>
                {(sharingCanChangeOwner || sharingCanChangeConsumer) && (
                  <ListItem onClick={openSharingSettingsModal}>
                    <i className="fas fa-exchange-alt" />
                    Sharing Settings
                  </ListItem>
                )}
              </ul>
            </ListItem>
            {isDeleteClientEnabled && (
              <ListItem
                onClick={() => this.setIsDeleteClientModalOpen(true)}
                className="red border-top"
              >
                <i className="far fa-trash-alt" />
                {deleteActionLabel}
              </ListItem>
            )}
          </ul>

          <AdvModal
            isOpen={isSharingSettingsModalOpen}
            onRequestClose={closeSharingSettingsModal}
            shouldCloseOnOverlayClick={false}
            className="popup sharing-settings-popup"
            overlayClassName="closerdiv"
          >
            {modalErrors && modalErrors.length > 0 ? (
              <div className="confirm">
                <p>
                  {modalErrors.map(error => (
                    <div key={error}>{error}</div>
                  ))}
                </p>
                <div className="actions">
                  <button type="button" onClick={() => setModalErrors([])}>
                    Close
                  </button>
                </div>
              </div>
            ) : (
              <SharingSettings clientId={client.Id} onReturn={closeSharingSettingsModal} />
            )}
          </AdvModal>
        </UserInformation>

        {isClientAccessOpen && (
          <ClientAccess
            clientId={client.Id.toString()}
            onClose={() => this.setIsClientAccessOpen(false)}
          />
        )}

        {isCloneClientModalOpen && (
          <AddClientModal
            clientToClone={{
              id: client.Id,
              firstName: client.FirstName,
              lastName: client.LastName,
            }}
            onClose={() => this.setIsCloneClientModalOpen(false)}
          />
        )}

        {isDeleteClientModalOpen && (
          <DeleteClientModal
            clientId={client.Id}
            onClose={() => this.setIsDeleteClientModalOpen(false)}
          />
        )}
      </>
    );
  }
}

ClientMenuView.defaultProps = {
  canInviteConsumer: false,
};

ClientMenuView.propTypes = {
  client: PropTypes.shape({
    Id: PropTypes.number,
    FirstName: PropTypes.string,
    LastName: PropTypes.string,
    Email: PropTypes.string,
    IsRegistered: PropTypes.bool,
  }).isRequired,
  isDeleteClientEnabled: PropTypes.bool.isRequired,
  isCurrentPlan: PropTypes.bool.isRequired,
  downloadPdf: PropTypes.func.isRequired,
  resetPlan: PropTypes.func.isRequired,
  viewClientActivity: PropTypes.func.isRequired,
  viewClientSettings: PropTypes.func.isRequired,
  deleteActionLabel: PropTypes.string.isRequired,
  sharingCanChangeOwner: PropTypes.bool.isRequired,
  sharingCanChangeConsumer: PropTypes.bool.isRequired,
  isSharingSettingsModalOpen: PropTypes.bool.isRequired,
  openSharingSettingsModal: PropTypes.func.isRequired,
  closeSharingSettingsModal: PropTypes.func.isRequired,
  modalErrors: PropTypes.arrayOf(PropTypes.string).isRequired,
  setModalErrors: PropTypes.func.isRequired,
  canInviteConsumer: PropTypes.bool,
  isOnlineGlia: PropTypes.bool.isRequired,
  showGliaStatus: PropTypes.bool.isRequired,
  showFinancialPlanning: PropTypes.bool.isRequired,
  getGliaOnlineStatus: PropTypes.func.isRequired,
};

export default ClientMenuView;
